export const STATION_TEXT = {
	breakdownBadgeAriaLabel: 'Breakdown location',
};
